var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:currentColor;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.46 5.5V7.77H19.23V11.9C19.23 14.09 18.25 16.15 16.55 17.54C15.25 18.6 13.67 19.16 11.98 19.16C10.29 19.16 8.7 18.6 7.4 17.54C5.7 16.15 4.72 14.09 4.72 11.9V7.77H3.5V5.5H20.46ZM21.96 4H2V9.27H3.22V11.9C3.22 14.64 4.48 17.09 6.45 18.7C7.96 19.93 9.88 20.66 11.98 20.66C14.08 20.66 15.99 19.93 17.5 18.7C19.47 17.09 20.73 14.65 20.73 11.9V9.27H21.96V4Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.9795 12.6699C12.8295 12.6699 13.5195 13.3599 13.5195 14.2099C13.5195 15.0599 12.8295 15.7499 11.9795 15.7499C11.1295 15.7499 10.4395 15.0599 10.4395 14.2099C10.4395 13.3599 11.1295 12.6699 11.9795 12.6699ZM11.9795 11.1699C10.2995 11.1699 8.93945 12.5299 8.93945 14.2099C8.93945 15.8899 10.2995 17.2499 11.9795 17.2499C13.6595 17.2499 15.0195 15.8899 15.0195 14.2099C15.0195 12.5299 13.6595 11.1699 11.9795 11.1699Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.9992 10.1895C15.5492 10.1895 15.9992 10.6395 15.9992 11.1995V17.9495C14.8092 18.7495 13.4392 19.1595 11.9792 19.1595C10.5192 19.1595 9.13922 18.7395 7.94922 17.9495V11.1995C7.94922 10.6395 8.39922 10.1895 8.94922 10.1895H14.9992ZM14.9992 8.68945H8.94922C7.56922 8.68945 6.44922 9.80945 6.44922 11.1995V18.6995C7.95922 19.9295 9.87922 20.6595 11.9792 20.6595C14.0792 20.6595 15.9892 19.9295 17.4992 18.6995V11.1995C17.4992 9.80945 16.3792 8.68945 14.9992 8.68945Z",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCamera);
export default __webpack_public_path__ + "static/media/security-camera.5a09d3fa02c211f713db468a1b88e795.svg";
export { ForwardRef as ReactComponent };